<section
    class="flex md:flex-row flex-col w-full justify-between items-center p-3 py-2 gap-3"
>
    <section class="relative flex w-full justify-start items-center gap-2">
        <app-icon-button
            (click)="handleNavigate('prev', _mode()!, 1)"
            icon="ic:baseline-chevron-left"
        />
        <app-icon-button [cdkMenuTriggerFor]="c" size="sm">
            <p class="font-semibold text-base md:text-lg">
                {{ value() | date: "y년 MM월" }}
            </p>

            @if (mode() === "week") {
                <p class="ml-1 font-semibold text-base md:text-lg">
                    {{ weekText() }}
                </p>
            } @else if (mode() === "day") {
                <p class="ml-1 font-semibold text-base md:text-lg">
                    {{ value() | date: "dd일" }}
                </p>
            }
        </app-icon-button>
        <app-icon-button
            (click)="handleNavigate('next', _mode()!, 1)"
            icon="ic:baseline-chevron-right"
        />
        <ng-container *ngTemplateOutlet="today" />
    </section>
    <section
        class="flex flex-row gap-2 md:gap-3 items-center min-w-max w-full md:w-auto justify-between md:justify-start"
    >
        <div class="flex gap-2 md:gap-3 items-center">
            <app-tabs
                [options]="modes"
                [value]="_mode() || 'month'"
                (valueChange)="handleModeChange($event)"
            />
        </div>
        <ng-content />
    </section>
</section>

<ng-template #c>
    <div
        cdkMenu
        class="shadow-md fixed md:min-w-max md:inset-auto md:w-auto md:h-auto inset-0 items-center flex p-4 md:p-0 w-screen md:bg-transparent bg-black/70 h-screen z-[999] md:absolute md:top-[calc(100%+4px)]"
    >
        <app-input-calendar [date]="value()!" (select)="handleEvent($event)" />
    </div>
</ng-template>

<ng-template #today>
    <button
        (click)="handleToday()"
        class="flex items-center p-2 px-3.5 gap-1 justify-center rounded-xl hover:bg-gray-100 transition-colors bg-white border border-gray-300"
    >
        <p class="text-xs md:text-sm">오늘</p>
    </button>
</ng-template>
